export default __webpack_public_path__ + "static/media/qubic-login.18c04cfb.svg";